import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { P11, Particles } from "./p11shared";
import { useP11Lang } from "./p11lang";

// Eenmalige materiaal-voorbereiding (eerste dashboard-bezoek). Blokkeert nooit toegang.
export default function P11Preparation() {
  const nav = useNavigate();
  const { tt } = useP11Lang();
  const [equipment, setEquipment] = useState({});
  const [busy, setBusy] = useState(false);
  const items = tt("equipment_items");

  useEffect(() => {
    api.get("/project11/me/dashboard").then(({ data }) => setEquipment(data.participant.equipment || {})).catch(() => nav("/project11/login"));
  }, [nav]);

  const cycle = (item) => {
    const order = [null, "have", "need", "na"];
    const cur = equipment[item] || null;
    const next = order[(order.indexOf(cur) + 1) % order.length];
    setEquipment((p) => { const n = { ...p }; if (next) n[item] = next; else delete n[item]; return n; });
  };

  const save = async (help = false) => {
    setBusy(true);
    try {
      await api.put("/project11/me/equipment", { equipment });
      if (help) await api.post("/project11/me/equipment/help");
      nav("/project11/dashboard", { replace: true });
    } catch { toast.error("Opslaan mislukt"); } finally { setBusy(false); }
  };

  const stateStyle = (s) => s === "have" ? { borderColor: P11.yellow, color: P11.yellow } : s === "need" ? { borderColor: P11.gray2, color: P11.gray2 } : s === "na" ? { borderColor: P11.border, color: P11.gray } : { borderColor: P11.border, color: P11.gray };
  const stateLabel = (s) => s === "have" ? tt("have") : s === "need" ? tt("need") : s === "na" ? tt("na") : "—";

  return (
    <div className="p11-root relative" data-testid="p11-preparation">
      <Particles density={40} />
      <main className="relative z-10 min-h-screen max-w-xl mx-auto px-6 py-12 flex flex-col">
        <div className="p11-label-yellow">{tt("prep_01")}</div>
        <h1 className="p11-h1 text-3xl md:text-5xl mt-6">{tt("before_begin")}</h1>
        <p className="mt-6 text-base leading-relaxed" style={{ color: P11.gray2 }}>{tt("prep_body")}</p>
        <div className="mt-12 divide-y" style={{ borderColor: P11.border }} data-testid="p11-equipment-list">
          {items.map((item, i) => (
            <button key={item} onClick={() => cycle(item)} className="w-full flex items-center justify-between py-4 text-left group" data-testid={`p11-equipment-${i}`}>
              <span className="text-sm" style={{ color: P11.text }}>{item}</span>
              <span className="p11-label px-3 py-1.5 border transition-colors" style={stateStyle(equipment[item])} data-testid={`p11-equipment-state-${i}`}>{stateLabel(equipment[item])}</span>
            </button>
          ))}
        </div>
        <div className="mt-12 space-y-3">
          <button onClick={() => save(true)} disabled={busy} className="p11-btn-ghost w-full justify-center" data-testid="p11-equipment-help">{tt("need_info")}</button>
          <button onClick={() => save(false)} disabled={busy} className="p11-btn w-full" data-testid="p11-equipment-ready">{tt("ready")}</button>
        </div>
      </main>
    </div>
  );
}
